import { makeAnalyticsAction, } from '../analytics/analytics-utils.js';
import { SearchPageEvents } from '../analytics/search-action-cause.js';
//TODO: KIT-2859
export const logDidYouMeanClick = () => makeAnalyticsAction('analytics/didyoumean/click', (client) => client.makeDidYouMeanClick());
//TODO: KIT-2859
export const logDidYouMeanAutomatic = () => makeAnalyticsAction('analytics/didyoumean/automatic', (client) => client.makeDidYouMeanAutomatic());
export const didYouMeanClick = () => ({
    actionCause: SearchPageEvents.didYouMeanClick,
});
export const didYouMeanAutomatic = () => ({
    actionCause: SearchPageEvents.didYouMeanAutomatic,
});
